import type React from 'react';
import { forwardRef } from 'react';

export default forwardRef<
  HTMLImageElement,
  React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
>(function Image(props, ref) {
  // eslint-disable-next-line jsx-a11y/alt-text -- alt is sent as prop
  return <img {...props} ref={ref} />;
});
